












































































































































































































































































































































































































































interface Form {
  selectLabel: string | undefined;
  selectValue: string | undefined;
  wareTitle: string | undefined;
  wareType: number[];
  payTime: Moment[];
  salesman: string | undefined;
  withdrawStatus: string | undefined;
  status: string | undefined;
  saler_type: string | undefined;
}
interface Model {
  refundType: string | undefined;
  refundReason: string | undefined;
  logisticsCompany: any | undefined;
  logisticsOrderId: string | undefined;
}
import { Component, Vue } from 'vue-property-decorator';
import { date } from '@/util/adapter';
import { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import storage from 'baimahu/storage';
const uuidv4 = require('uuid/v4');
const { VUE_APP_API, VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${VUE_APP_API}/qy/order/list-for-merchant`,
  fuzzyMatching: `${VUE_APP_API}/qy/user/fuzzy-matching`,
  export: `${FCAPI}/shang/setting/order/export?`,
  refund: `${VUE_APP_API}/qy/order/refund`,
  companyList: `${VUE_APP_API}/widget/delivery/company-list`,
  delivery: `${VUE_APP_API}/qy/order/delivery`,
  clerk_list: `${VUE_APP_API}/qy/user/clerk/search`,
  activity_order: `${VUE_APP_API}/qy/order/list-for-merchant`,
};
const OPTION_LIST = [
  {
    _key: uuidv4(),
    label: '订单号',
    value: '1',
  },
  {
    _key: uuidv4(),
    label: '收货人姓名',
    value: '2',
  },
  {
    _key: uuidv4(),
    label: '收货人手机号',
    value: '3',
  },
  {
    _key: uuidv4(),
    label: '收货人地址',
    value: '4',
  },
];
const WARE_TYPE_LIST = [
  {
    value: '0',
    label: '全部',
  },
  {
    value: '1',
    label: '实物',
  },
  {
    value: '2',
    label: '虚拟',
    children: [
      {
        value: '0',
        label: '无',
      },
      {
        value: '1',
        label: '兑换码',
      },
    ],
  },
];
const WITHDRAW_STATUS_LIST = [
  {
    _key: uuidv4(),
    label: '全部',
    value: '1',
  },
  {
    _key: uuidv4(),
    label: '不可提现',
    value: '5',
  },
  {
    _key: uuidv4(),
    label: '可提现',
    value: '10',
  },
  {
    _key: uuidv4(),
    label: '提现中',
    value: '15',
  },
  {
    _key: uuidv4(),
    label: '已到账',
    value: '20',
  },
];
const STATUS_LIST = [
  {
    _key: uuidv4(),
    label: '全部',
    value: undefined,
  },
  {
    _key: uuidv4(),
    label: '待付款',
    value: '1',
  },
  {
    _key: uuidv4(),
    label: '待发货',
    value: '5',
  },
  {
    _key: uuidv4(),
    label: '已发货',
    value: '10',
  },
  {
    _key: uuidv4(),
    label: '已完成',
    value: '15',
  },
  {
    _key: uuidv4(),
    label: '已取消',
    value: '20',
  },
  {
    _key: uuidv4(),
    label: '已退款',
    value: '25',
  },
];
const REFUND_TYPE_LIST = [
  {
    _key: uuidv4(),
    label: '退货款不退邮费',
    value: '1',
  },
  {
    _key: uuidv4(),
    label: '退货款且退邮费',
    value: '2',
  },
];
const VALIDATE = {
  isRefundType: false,
  isRefundReason: false,
  isCompany: false,
  isOrderId: false,
};

function getData(remote?: RemotePagination<any>) {
  remote = (remote || {}) as RemotePagination<any>;
  return {
    total: remote.total || 1,
    per_page: remote.per_page || 1,
    current_page: remote.current_page || 1,
    last_page: remote.last_page || 1,
    data: remote.data || [],
  };
}
@Component
export default class OrderList extends Vue {
  isLoading: boolean = false;
  form: Form = {
    selectLabel: '1',
    selectValue: undefined,
    wareTitle: undefined,
    wareType: [0],
    payTime: [],
    salesman: undefined,
    withdrawStatus: '1',
    status: undefined,
    saler_type: undefined,
  };
  send_data: any = {};
  page: any = '';
  optionList: any = OPTION_LIST;
  wareTypeList: any = WARE_TYPE_LIST;
  salesmanList: any = [];
  withdrawStatusList: any = WITHDRAW_STATUS_LIST;
  statusList: any = STATUS_LIST;
  refundTypeList: any = REFUND_TYPE_LIST;
  validate: any = VALIDATE;
  table_data: any = getData();
  isShowRefund: boolean = false;
  isShowLogistics: boolean = false;
  modelLayout: any = {
    labelCol: { span: 5 },
    wrapperCol: { span: 19 },
  };
  modelOrderLayout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  };
  model: Model = {
    refundType: undefined,
    refundReason: undefined,
    logisticsCompany: undefined,
    logisticsOrderId: undefined,
  };
  modelItem: any = {};
  companyList: any = [];
  failterCompanyList: any = [];
  isShowFooter: boolean = false;
  isButtonLoading: boolean = true;
  clerk_list_all: any = [];
  timeout: any = null;
  fetching: boolean = false;
  order_type: string = '';
  request_id: string = '';
  getSendData() {
    const send_data: any = {};
    const form = this.form;
    const startTime: Moment = form.payTime[0];
    const endTime: Moment = form.payTime[1];
    send_data.page = this.page;
    switch (form.selectLabel) {
      case '1':
        send_data.trade_no = form.selectValue ? form.selectValue : undefined;
        break;
      case '2':
        send_data.express_name = form.selectValue;
        break;
      case '3':
        send_data.express_mobile = form.selectValue;
        break;
      case '4':
        send_data.express_address = form.selectValue;
        break;
    }
    send_data.title = form.wareTitle;
    send_data.ware_type = form.wareType[0];
    send_data.ware_type_secondary = form.wareType[1] ? form.wareType[1] : 0;
    send_data.start_time = startTime ? date(startTime) : undefined;
    send_data.end_time = endTime ? date(endTime) : undefined;
    send_data.clerk_code = form.salesman;
    send_data.withdraw_status = form.withdrawStatus !== '1' ? form.withdrawStatus : undefined;
    send_data.status = form.status;
    send_data.clerk_performance = this.$route.query.clerk_performance
      ? this.$route.query.clerk_performance
      : undefined;
    this.send_data = send_data;
  }

  query(page: number = 1) {
    this.isLoading = true;
    this.page = page;
    this.getSendData();
    return this.$axios
      .get(API.query, { params: this.send_data })
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          this.$message.error(remote.message);
          return;
        }
        const data = remote.data || {};
        data.data.forEach((item: any) => {
          if (item.sku_attribute_json) {
            item.sku_detail = JSON.parse(item.sku_attribute_json);
          }
        });
        this.table_data = getData(data);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  changeSleectLabel(value: any) {
    if (value === undefined) {
      this.form.selectValue = undefined;
    }
  }

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.query(next_page);
  }

  paginationOption(data: RemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }
  // 防止出现 0.1+0.2=0.30000000000000004的情况，整数显示为整数，小数显示两位小数
  numberFormat(num: any) {
    return Number((num / 100).toFixed(2));
  }

  refund(item: any) {
    this.isShowRefund = true;
    this.modelItem = item;
  }

  focusModel(type: string, key: string) {
    this.validate[type] = false;
  }

  validateModel(type: string, key: string) {
    this.validate[type] = !(this.model as any)[key];
  }

  submitRefund() {
    if (!this.model.refundType) {
      this.validate.isRefundType = true;
      return;
    }
    if (!this.model.refundReason) {
      this.validate.isRefundReason = true;
      return;
    }
    if (!this.model.refundReason.trim()) {
      this.validate.isRefundReason = true;
      return;
    }
    if (this.isButtonLoading) {
      this.isButtonLoading = false;
      const send_data: any = {};
      send_data.trade_no = this.modelItem.trade_no;
      send_data.refund_type = this.model.refundType;
      send_data.refund_reason = this.model.refundReason;
      this.$axios
        .post(API.refund, send_data)
        .then((res: AxiosResponse) => {
          const remote = res.data;
          if (remote.error !== 0) {
            this.$message.error(remote.message);
            return;
          }
          this.isShowRefund = false;
          this.$message.success('退款成功');
          this.model.refundType = '';
          this.model.refundReason = '';
        })
        .finally(() => {
          this.isButtonLoading = true;
          this.query(this.page);
        });
    }
  }

  logistics(item: any, type: any) {
    this.isShowLogistics = true;
    this.modelItem = item;
    this.isShowFooter = type;
  }

  submitLogistics() {
    if (!this.model.logisticsCompany) {
      this.validate.isCompany = true;
      return;
    }
    if (!this.model.logisticsOrderId) {
      this.validate.isOrderId = true;
      return;
    }
    if (this.isButtonLoading) {
      this.isButtonLoading = false;
      const send_data: any = {};
      send_data.trade_no = this.modelItem.trade_no;
      send_data.logistics_company_code = this.model.logisticsCompany[0].code;
      send_data.logistics_company_name = this.model.logisticsCompany[0].name;
      send_data.logistics_order_no = this.model.logisticsOrderId;
      this.$axios
        .post(API.delivery, send_data)
        .then((res: AxiosResponse) => {
          const remote = res.data;
          if (remote.error !== 0) {
            this.$message.error(remote.message);
            return;
          }
          this.isShowLogistics = false;
          this.$message.success('发货成功');
          this.model.logisticsOrderId = '';
        })
        .finally(() => {
          this.isButtonLoading = true;
          this.query(this.page);
        });
    }
  }

  clearForm() {
    const form = this.form;
    form.selectLabel = '1';
    form.selectValue = undefined;
    form.wareTitle = undefined;
    form.wareType = [0];
    form.payTime = [];
    form.salesman = undefined;
    form.withdrawStatus = '1';
    form.saler_type = undefined;
    this.$route.query.clerk_performance = '';
  }

  handleSearch(value: string) {
    this.failterCompanyList = value
      ? this.companyList.filter((item: any) => item.name.match(value))
      : [];
  }

  handleChange(value: string) {
    this.validate.isCompany = !value;
    this.failterCompanyList = value
      ? this.companyList.filter((item: any) => item.name.match(value))
      : [];
    this.model.logisticsCompany = value
      ? this.companyList.filter((item: any) => item.name === value)
      : undefined;
  }

  getCompanyList() {
    return this.$axios.get(API.companyList).then((res: AxiosResponse) => {
      const remote = res.data;
      if (remote.error !== 0) {
        this.$message.error(remote.message);
        return;
      }
      // data返回的数据有name相同的，先去重
      const obj: any = {};
      for (const i of remote.data) {
        if (!obj[i.name]) {
          this.companyList.push(i);
          obj[i.name] = true;
        }
      }
    });
  }

  searchSalesman(value: any) {
    if (!this.form.saler_type) {
      return;
    }
    if (!value) {
      this.clerk_list_all = [];
      return;
    }
    this.fetching = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getClerkList(value);
    }, 1000 * Math.random());
  }

  getClerkList(name: any) {
    return this.$axios
      .get(`${API.clerk_list}?level=${this.form.saler_type}&fuzzy_name=${name}`)
      .then((res: AxiosResponse) => {
        const remote = res.data;
        if (remote.error !== 0) {
          this.$message.error(remote.message);
          return;
        }
        this.clerk_list_all = remote.data;
        if (this.clerk_list_all.length === 0) {
          this.fetching = false;
        }
      });
  }

  submit() {
    this.$route.query.clerk_performance = '';
    this.query();
  }

  exportData() {
    this.getSendData();
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    this.send_data.merchant_id = merchant_id;
    const params = this.send_data;
    let url = '';
    url = API.export;
    for (const key in params) {
      if (key && params[key]) {
        url += `&${key}=${params[key]}`;
      }
    }
    window.location.href = url;
  }

  changeSaler(value: any) {
    this.form.salesman = undefined;
  }

  // 获取活动订单
  getActivityOrder(type: any, id: any) {
    // type表示订单类型，ID表示请求参数：activity_id活动订单id，room_id直播订单id
    this.isLoading = true;
    this.$axios
      .get(`${API.activity_order}?${type}=${id}&is_paid=1`)
      .then((res: AxiosResponse) => {
        if (res.status !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        res.data.data.data.forEach((item: any) => {
          if (item.sku_attribute_json) {
            item.sku_detail = JSON.parse(item.sku_attribute_json);
          }
        });
        this.table_data = getData(res.data.data);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  async created() {
    this.form.status = this.$route.query.status ? String(this.$route.query.status) : undefined;
    this.form.saler_type = this.$route.query.level ? String(this.$route.query.level) : undefined;
    if (this.$route.query.clerk_id && this.$route.query.level) {
      this.form.salesman = String(this.$route.query.clerk_id);
    }
    this.form.selectValue = this.$route.query.order_id
      ? String(this.$route.query.order_id)
      : undefined;
    if (this.$route.query.order_type) {
      if (+this.$route.query.order_type === 1) {
        await this.getActivityOrder('activity_id', this.$route.query.activity_id);
      } else if (this.$route.query.order_type === '2') {
        await this.getActivityOrder('room_id', this.$route.query.room_id);
      }
    } else {
      await this.query();
    }
    await this.getCompanyList();
  }
}
